import { Component, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { ToolDescriptionByTypeService, ToolService, ToolTypeService, ToolNumberService } from '../../../camtl.service';

import { Tool } from '../../../../../shared/model';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { Subject } from 'rxjs';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { ToolHandednessService } from '../../../../mesc/mesc.service';
import { MasterToolListBase } from '../../master-tool-list-base.component';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { Subscription } from 'rxjs/Subscription';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-furnished-equipment-tools',
  templateUrl: './furnished-equipment-tools.component.html',
  // styleUrls: ['./furnished-equipment-tools.component.scss']
})

export class FurnishedEquipmentToolsComponent extends MasterToolListBase implements OnInit, OnDestroy {

  constructor(
    toolTypeService: ToolTypeService,
    public service: ToolService,
    private systemSelectService: SystemSelectService,
    public toolDescriptionService: ToolDescriptionByTypeService,
    private toolNumberService: ToolNumberService,
    private formBuilder: FormBuilder,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private toolHandednessService: ToolHandednessService,
    public routeValidationService: RouteValidationService) {
    super(toolTypeService, "Furnished Equipment", toolDescriptionService);
  }

  editForm: FormGroup;
  isNew: boolean = false;
  editDataItem: Tool;
  showBlock: boolean = false;

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  columns: any[] = [{
    field: 'ToolDetail.ToolNumber',
    title: 'Tool Number',
    width: 110
  },
  {
    field: 'ToolDescription',
    title: 'Description'
  },
  {
    field: 'AdditionalInfo',
    title: 'Additional Info'
  },
  {
    field: 'ToolHandedness',
    title: 'Design Handedness'
  },
  {
    field: 'LeftCount',
    title: 'LH',
    width: 70
  },
  {
    field: 'RightCount',
    title: 'RH',
    width: 70
  },
  {
    field: 'SingleCount',
    title: 'S',
    width: 70
  },
  {
    field: "MakeFurnish",
    title: "M/F",
    width: 70
  },
  {
    field: "AssignToolNumber",
    title: "Assign Tool No.",
    template: {
      type: "boolean",
      onLabel: "True",
      offLabel: "False"
    },
    width: 80
  },
  {
    field: "AssignJobNumber",
    title: "Assign Job No.",
    template: {
      type: "boolean",
      onLabel: "True",
      offLabel: "False"
    },
    width: 80
  },
  {
    field: "AssignLocationNumber",
    title: "Assign Location No.",
    template: {
      type: "boolean",
      onLabel: "True",
      offLabel: "False"
    },
    width: 105
  }];

  moveToBuild = (e, dataItem, service: ToolService, system, callbackInputs) => {
    var self = this;
    dataItem.MakeFurnish = "M";
    dataItem.ToolTypeId = this.buildToolId;
    dataItem.IsActive = true;
    service.save(dataItem, false, "", true, false).then(function () {
      self.service.loading.next(false);
      self.getToolDescriptions("Furnished Equipment");
      self.grid.refresh(true);
      self.cgpSnackbarService.showSnackbar({
        message: 'Tool has been moved',
        duration: 2000
      });
    }).catch(function (response) {
      dataItem.MakeFurnish = "F";
      self.service.loading.next(false);
      self.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: response._body.replace(/"/g, ''),
        alert: 'danger',
        closeLabel: 'Close',
      })
    });
  }

  private customButtons = [
    {
      id: "toggleToBuild",
      class: "fa fa-reply",
      callback: this.moveToBuild,
      title: 'Move to Build',
    }];

  showBlockWindow = (e, service, system, callbackInputs) => {
    this.showBlock = true;
  }

  private customToolbarButtons = [
    {
      id: "blockToolNumbersFurnished",
      iconClass: "fa fa-lock",
      title: "Block Tool Numbers",
      text: "Block Tool Numbers",
      callback: this.showBlockWindow,
      callbackInputs: this.showBlock
    }
  ];

  onRead = (): Promise<any> => {
    var self = this;
    if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/FurnishedEquipmentTools')) {
      return this.toolTypeService.read()
        .then(function (response: any) {
          self.furnishedId = response.filter(function (item) {
            return item.Description.toUpperCase() === "FURNISHED EQUIPMENT";
          })[0].Id;

          self.buildToolId = response.filter(function (item) {
            return item.Description.toUpperCase() === "TOOL";
          })[0].Id;

          return self.toolDescriptionService.read("/" + self.furnishedId + "/toolDescription", true).then(function () {
            return self.service.read('/' + self.system.Id + "/toolType/" + self.furnishedId, true).then(function (response) {
              for (var i = 0; i < response.length; i++) {
                response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
              }
              return response;
            });
          });
        })
    }
  }

  disableToolbar = (controlName: string) => {
    let isDisabled: boolean = false;
    if (!this.furnishedId && controlName === "add") {
      isDisabled = true;
    }
    return isDisabled;
  }

  onToolSave = (dataItem, isNew) => {
    var self = this;
    this.service.save(dataItem, isNew, "", true, false, false).then(function () {
      self.service.loading.next(false);
      self.grid.refresh(true);
      self.cgpSnackbarService.showSnackbar({
        message: isNew ? "Record has been created" : "Record has been updated",
        duration: 2000
      });
      self.toolNumberService.read("/" + self.system.Id + "/blockedtoolnumbers", true)
        .then(function (response) {
          self.toolNumberService.data = self.stringToObjectArray(response);
        });
    }).catch(function (response) {
      self.service.loading.next(false);
      self.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: response._body.replace(/"/g, '').replace(/Value cannot be null\.\\r\\nParameter name: /g, ''),
        alert: 'danger',
        closeLabel: 'Close',
      })
    })
  }


  handleDelete = (dataItem): Promise<any> => {
    return this.service.remove('/' + dataItem.Id);
  }

  handleHandednessChange = (toolHandednessId: string = "") => {
    var handednessName = "";

    let handedness = this.toolHandednessService.data.find(
      handedness => toolHandednessId === handedness.Id
    )

    if (handedness) {
      handednessName = handedness.Name
    }
    this.editForm.removeControl("LeftCount");
    this.editForm.removeControl("RightCount");
    this.editForm.removeControl("SingleCount");

    if (handednessName === "S") {
      this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    }
    else if (handednessName === "L" || handednessName === "R") {
      this.editForm.addControl("LeftCount", new FormControl(0, Validators.required))
      this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
    } else {
      this.editForm.addControl("LeftCount", new FormControl(0, Validators.required))
      this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
      this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    }
  }

  onEdit = (dataItem) => {
    this.handleHandednessChange(dataItem.ToolHandednessId);
  }



  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
      width: 150,
      customToolbar: this.customToolbarButtons,
      isDisabled: this.disableToolbar
    },
    read: this.onRead,
    delete: this.handleDelete,
    columns: this.columns,
    service: this.service,
    save: this.onToolSave,
    edit: this.onEdit,
    fileName: "furnished_equipment_tools.xlsx",
    displayField: "DisplayNumber"
  };

  ngOnInit() {
    var self = this;
    this.editForm = this.formBuilder.group({
      Id: [],
      ToolNumber: [{ value: [] }],
      ToolDescriptionId: [{ value: [] }, Validators.required],
      ToolDescription: [""],
      AdditionalInfo: [""],
      ToolHandednessId: ["", Validators.required],
      DesignHandedness: [{ value: [] }],
      LeftCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      RightCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      SingleCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      AssignToolNumber: [false],
      AssignJobNumber: [false],
      AssignLocationNumber: [false],
      CreatedBy: [],
      CreatedDate: [],
      SystemId: [""],
      MakeFurnish: [""],
      ToolTypeId: [""],
      ToolTypeName: [""]
    })

    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        this.editDataItem = undefined;
        this.toolHandednessService.query();
        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/FurnishedEquipmentTools')) {
          this.toolNumberService.getBlockedToolNumbersForSystem(this.system.Id).then(function () {
            self.toolNumberService.data = self.stringToObjectArray(self.toolNumberService.data);
          });
        }
      });

    this.systemSelectService.get();
    this.moveToBuild.bind(this);
  }

  stringToObjectArray(array) {
    var objectArray = [];
    for (var i = 0; i < array.length; i++) {
      var object = {
        value: array[i]
      };

      objectArray.push(object);
    }
    return objectArray;
  }

  closeForm() {
    this.showBlock = false;
  }

  onCancel(e) {
    e.preventDefault();
    this.closeForm();
  }

  disableBlock(form) {
    if (!parseInt(form.lastElementChild.value) || parseInt(form.lastElementChild.value) < 1) {
      return true;
    }
    return false;
  }

  onSave(e, blockToolQuantity) {
    var self = this;
    e.preventDefault();
    this.service.blockToolNumbers(this.system.Id, blockToolQuantity).then(function () {
      self.service.loading.next(false);
      self.showBlock = false;
      self.cgpSnackbarService.showSnackbar({
        message: blockToolQuantity == 1 ? '1 tool number was generated' : blockToolQuantity + ' tool numbers were generated',
        duration: 2000
      });
      self.toolNumberService.getBlockedToolNumbersForSystem(self.system.Id).then(function () {
        self.toolNumberService.data = self.stringToObjectArray(self.toolNumberService.data);
      });
      self.service.loading.next(false);
    })
  }



  formDialog = {
    title: "Furnished Equipment Tool",
    formControls: [
      {
        type: 'combobox',
        name: 'ToolNumber',
        title: 'Tool Number',
        readonly: 'update',
        placeholder: 'Select Tool Number',
        service: this.toolNumberService,
        textField: "value",
        valueField: "value",
        sync: true
      },
      {
        type: 'combobox',
        name: "ToolDescriptionId",
        title: "Tool Description",
        placeholder: 'Select Tool Description',
        textField: "Name",
        valueField: "Id",
        service: this.toolDescriptionService
      },
      {
        type: 'text',
        name: 'AdditionalInfo',
        title: 'Additional Info'
      },
      {
        type: 'combobox',
        name: 'ToolHandednessId',
        title: 'Design Handedness',
        onChange: this.handleHandednessChange,
        textField: 'Name',
        valueField: 'Id',
        placeholder: 'Select Design Handedness...',
        service: this.toolHandednessService
      },
      {
        type: 'number',
        name: 'LeftCount',
        title: 'LH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'RightCount',
        title: 'RH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'SingleCount',
        title: 'S',
        minimum: 0,
        step: 1
      },
      {
        type: 'presetCombobox',
        name: 'MakeFurnish',
        title: 'M/F',
        placeholder: 'M/F',
        textField: 'value',
        valueField: 'value',
        readonly: 'update',
        data: [
          { "value": "M" },
          { "value": "F" }
        ]
      },
      {
        type: 'boolean',
        name: 'AssignToolNumber',
        title: 'Assign Tool Number'
      },
      {
        type: 'boolean',
        name: 'AssignJobNumber',
        title: 'Assign Job Number'
      },

      {
        type: 'boolean',
        name: 'AssignLocationNumber',
        title: 'Assign Location Number'
      },
    ]
  }

  setModelHandler() {
    this.editDataItem = new Tool();
    this.editDataItem.ToolTypeId = this.furnishedId;
    this.editDataItem.MakeFurnish = "F";
    this.editDataItem.AssignJobNumber = false;
    this.editDataItem.AssignLocationNumber = false;
    this.editDataItem.AssignToolNumber = false;
    this.editDataItem.LeftCount = 0;
    this.editDataItem.RightCount = 0;
    this.editDataItem.SingleCount = 0;
    this.editForm.addControl("LeftCount", new FormControl(0, Validators.required));
    this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
    this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }

}
